const account = {
  getAccountVariables: function() {
    return this.$store.getters
      .fetcher({
        query: `{
          GetAccountVariables {
            Account_Types{
              Account_Type_Id
              Title
              Description
            }
            Billing_Methods{
              Billing_Method_Id
              Title
              Description
            }
            Account_Type_Organization_Types{
              Account_Type_Id
              Organization_Type{
                Organization_Type_Id
                Title
                Order
              }
            }
            Organization_Types{
              Organization_Type_Id
              Title
              Order
            }
            States{
              State_Id
              Name
            }
          }
        }`
      })
      .then(res => res.data.GetAccountVariables);
  },

  getAccount: async function(accountId) {
    return await this.$store.getters
      .fetcher({
        query:
          `{
        GetAccount(id: ` +
          accountId +
          `) {
          Account_Id
          Account_Name
          Billing_Name
          Billing_Address_Line_1
          Billing_Address_Line_2
          Billing_City
          Billing_State {
            State_Id
            Name
          }
          Billing_Zip
          Billing_Phone
          Account_Type{
            Account_Type_Id
            Title
          }
          Billing_Method{
            Billing_Method_Id
            Title
          }
          Organizations {
            Organization_Id
            Name
            Parent_Organization_Id
            Organization_Type{
              Organization_Type_Id
              Title
            }
            Subjects(userId: ` +
          parseInt(this.$store.getters.user.User_Id) +
          `) {
              Subject_Id
              Title
            }
            Users {
              User_Id
              First_Name
              Last_Name
              Email
              Phone
            }
            Child_Organizations{
              Organization_Id
              Name
              Parent_Organization_Id
            }
          }
        }
      }`
      })
      .then(r => {
        return r.data.GetAccount;
      });
  },
  /*
  Users {
    Organization_Id
    Permissions{
      UserPermission_Id
      Organization {
        Organization_Id
        Name
      }
      Permission {
        Permission_Id
        Title
      }
    }
  }
  */

  getMyAccountsBasic: async function() {
    return await this.$store.getters
      .fetcher({
        query:
          `{
          GetUserAccounts(userId: ` +
          this.$store.getters.user.User_Id +
          `) {
            Account_Id
            Account_Name
            Account_Type{
              Account_Type_Id
              Title
            }
          }
        }`
      })
      .then(r => {
        return r.data.GetUserAccounts;
      });
  },

  createAccount: function(accountToCreate) {
    const query = `
      mutation($accountName: String!, $billingName: String!, $billingAddressLine1: String!, $billingAddressLine2: String!, $billingCity: String!, $billingState: Int!, $billingZip: String!, $billingEmail: String!, $billingPhone: String!, $accountTypeId: Int!, $billingMethodId: Int! ) {
        CreateAccount(accountName: $accountName, billingName: $billingName, billingAddressLine1: $billingAddressLine1, billingAddressLine2: $billingAddressLine2, billingCity: $billingCity, billingState: $billingState, billingZip: $billingZip, billingEmail: $billingEmail, billingPhone: $billingPhone, accountTypeId: $accountTypeId, billingMethodId: $billingMethodId ) {
          Account_Id
        }
      }`;
    const variables = {
      accountName: accountToCreate.Account_Name,
      billingName: accountToCreate.Billing_Name,
      billingAddressLine1: accountToCreate.Billing_Address_Line_1,
      billingAddressLine2: accountToCreate.Billing_Address_Line_2,
      billingCity: accountToCreate.Billing_City,
      billingState: parseInt(accountToCreate.State.State_Id),
      billingZip: accountToCreate.Billing_Zip,
      billingEmail: accountToCreate.Billing_Email,
      billingPhone: accountToCreate.Billing_Phone,
      billingMethodId: parseInt(
        accountToCreate.Billing_Method.Billing_Method_Id
      ),
      accountTypeId: parseInt(accountToCreate.Account_Type.Account_Type_Id)
    };
    return this.$store.getters.fetcher({ query, variables }).then(res => {
      accountToCreate.Account_Id = res.data.CreateAccount.Account_Id;
      return accountToCreate;
    });
  }
};

export { account };
